export default {
  init() {
    // JavaScript to be fired on the about us page
    var $scrollTo = $('.scroll-to')
    if($scrollTo.length){
		var offset = $('.scroll-to').first().offset().top - 100;
		$('html, body').animate({ scrollTop: offset }, 1000);
	}
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js